import { createFileRoute } from '@tanstack/react-router';
import { UpdateEmailPage } from '../components/pages/SettingsPage/UpdateEmailPage';

export const Route = createFileRoute('/account/settings_/email')({
  component: UpdateEmailPage,
});
